import { ReactElement } from "react";
import { t } from "@lingui/macro";

import { EmptyState } from "components/placeholder/empty-state";
import PageContainer from "containers/page-container";
import generalEmptyImage from 'assets/empty_state.png';

export default function EmptyStatePage(): ReactElement {
  return (
    <PageContainer>
      <EmptyState
        title={t`No functionalities yet`}
        illustration={generalEmptyImage}
        description={t`These will be available after installation`}
        visible={true}
      />
    </PageContainer>
  )
}